import React from 'react';

// ── CollapsibleCard ────────────────────────────────────────────────────────
//
// A tappable, collapsible box: icon + title (+ optional badge) + one-line
// summary + chevron, with the body shown only when open. Controlled — the
// parent owns the open state — so open/close can be driven by logic (e.g.
// auto-open when nothing is configured) and by scroll-to affordances.
//
// Used for every section on the Alerts page (notification methods, when to
// alert, leak & usage) so they all read as the same pattern.

function Chevron({ open }) {
  return (
    <svg className={`collapse-chev ${open ? 'is-open' : ''}`} width="18" height="18"
      viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}

export default function CollapsibleCard({
  icon, title, badge, summary, open, onToggle, locked, headRef, children,
}) {
  return (
    <section className={`collapse-card ${locked ? 'is-locked' : ''}`}>
      <button type="button" className="collapse-head" onClick={onToggle}
        aria-expanded={open} ref={headRef}>
        {icon && <span className="collapse-head__icon">{icon}</span>}
        <span className="collapse-head__main">
          <span className="collapse-title">{title}{badge}</span>
          {summary != null && <span className="collapse-summary">{summary}</span>}
        </span>
        <Chevron open={open} />
      </button>
      {open && <div className="collapse-body">{children}</div>}
    </section>
  );
}
